import React, { useContext } from 'react';
import { Box, Theme, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ReactComponent as CopilotChatButton } from '../../svg/mindtickle/mt-buyer-copilot-chat-button.svg';
import { useI18n } from '../../lib/hook/useI18n';
import { OrganizationThemeContext } from '../../lib/context/OrganizationThemeContext';

const useStyles = makeStyles((theme: Theme) => ({
  iconContainer: {
    alignItems: 'center',
    borderRadius: theme.spacing(15),
    display: 'flex',
    height: theme.spacing(2.5),
    justifyContent: 'center',
    width: theme.spacing(2.5),
  },
  buttonContainer: {
    display: 'flex',
    flex: 'auto',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: theme.spacing(1),
    cursor: 'pointer',
  },
}));

export interface BuyerCopilotButtonProps {
  onClick?: () => void;
  disabled?: boolean;
}

const BuyerCopilotFullScreenHeader: React.FC<BuyerCopilotButtonProps> = (
  props: BuyerCopilotButtonProps
) => {
  const { onClick, disabled = false } = props;
  const { buttonsStyles } = useContext(OrganizationThemeContext);

  const classes = useStyles();
  const { t } = useI18n();
  return (
    <Box className={classes.buttonContainer} onClick={onClick}>
      <Box
        className={classes.iconContainer}
        sx={() => ({
          backgroundColor: disabled
            ? 'var(--buyer-copilot-disabled)'
            : buttonsStyles?.backgroundColor || 'var(--buyer-copilot-enabled)',
          '&:hover': {
            transform: disabled ? 'none' : 'scale(1.05)',
          },
        })}
      >
        <CopilotChatButton width={13} height={13} />
      </Box>
      <Typography variant="body1">
        {t('buyerCopilot.content.ask_copilot')}
      </Typography>
    </Box>
  );
};

export default BuyerCopilotFullScreenHeader;
